<td class="shrink pr-0" *ngIf="incoming">
  <app-list-item-checkbox
    (check)="onToggleSelected()"
    [checked]="isChecked"
    [id]="document.id"
  ></app-list-item-checkbox>
</td>
<td>
  <!-- <app-document-type-indicator [type]="document.type"></app-document-type-indicator> -->
  {{ document.type | translate | pepUcfirst }}
</td>
<td class="whitespace-pre">
  <a
    style="cursor: pointer"
    [routerLink]="[
      '../../documents',
      !document.incoming ? 'o' : 'i',
      'view',
      document.id
    ]"
  >
    <span *ngIf="document.number">{{ document.number }}</span>
  </a>
</td>
<td [class.text-danger]="isPast">
  <!-- In case of advance show different -->
  {{ document.dateDue || document.datePaid | pepDate: activeOrg.locale }}
</td>
<td>
  <a
    ngbTooltip="{{ document._documentClient.name }}"
    *ngIf="document.clientId && !document.incoming; else noClientLink"
    [routerLink]="[
      '../../clients',
      document.clientId,
      document.type,
      { paidInFull: false }
    ]"
  >
    {{ document._documentClient.name | pepEllipsis: 45 }}
  </a>
  <ng-template #noClientLink>
    <span
      *ngIf="document._documentClient"
      ngbTooltip="{{ document._documentClient.name }}"
    >
      {{ document._documentClient.name | pepEllipsis: 45 }}</span
    >
  </ng-template>
</td>

<!-- Status -->
<td class="text-center">
  <app-document-status-badge [document]="document"></app-document-status-badge>
</td>

<!-- Total owed -->
<td class="text-right">
  <i
    *ngIf="document.totalPaid !== 0"
    class="fe fe-info fe-fw"
    ngbTooltip="{{ 'Paid' | translate }}: {{
      document.totalPaid | pepCurrency: document.currencyId:activeOrg.locale
    }}"
  ></i>
  {{ remainingDue | pepCurrency: document.currencyId:activeOrg.locale }}
</td>

<!-- TODO: Add payment button -->

<td class="text-right shrink">
  <div
    class="dropdown position-static"
    ngbDropdown
    placement="bottom-right"
    container="body"
  >
    <a
      style="cursor: pointer"
      (click)="(false)"
      class="dropdown-ellipses dropdown-toggle"
      aria-haspopup="true"
      aria-expanded="false"
      data-toggle="dropdown"
      ngbDropdownToggle
      data-boundary="viewport"
    >
      <i class="far fa-ellipsis-v-alt text-secondary"></i>
    </a>
    <app-active-document-dropdown-menu
      class="dropdown-menu dropdown-menu-right"
      ngbDropdownMenu
      [document]="document"
      [incoming]="incoming"
      [isPast]="isPast"
      [currentLang]="currentLang"
      (addPayment)="onAddPayment()"
      (cancel)="onCancel()"
      (delete)="onDelete()"
    ></app-active-document-dropdown-menu>
  </div>
</td>
